import React, {useCallback, useState} from 'react'

import HeaderSpacer from '@/view/layout/HeaderSpacer'

import MenuItem from '@/view/menu/component/MenuItem'
import Logout from '@/view/menu/component/Logout'
import DeleteUserView from '@/view/user/DeleteUserView'
import DialogHeader from "@/view/layout/DialogHeader";


interface MenuProps {
    onClose: () => void
}


const MenuView: React.FC<MenuProps> = (props:MenuProps) => {
    const [noticeIcon, setNoticeIcon] = useState('notice-off')
    const handleOverlayClick = useCallback(() => props.onClose(), [props.onClose])


    return (
        <div className='menu b2_r'>
            <DialogHeader title='메뉴' onClose={handleOverlayClick} rightIcon = {`${noticeIcon.toString()} w-26px h-26px`} rightLink='notificationList'/>
            <HeaderSpacer/>    

            <MenuItem title='공지사항' link='board' className='border-top-gray' iconClass='next w-6px h-12px'/>
            <MenuItem title='회원 관리' link='member' className='border-top-gray' iconClass='next w-6px h-12px'/>
            <MenuItem title='경기장 관리' link='place' className='border-top-gray' iconClass='next w-6px h-12px'/>
            <MenuItem title='랭킹' link='rank' className='border-top-gray' iconClass='next w-6px h-12px'/>

            <Logout/>
            <DeleteUserView/>

        </div>
    );
}

export default MenuView;